import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { CreditAccount } from './CreditAccount'

@InputType()
export class GetCreditBalanceArgs extends ActionArgs {
  /** Target owner to read — a `User._id` (User scope) or `Tenant._id` (Tenant scope). Unlike `myCreditBalance`, the caller supplies this explicitly and must hold `canManageAiBilling`. */
  @Field(() => ID)
  ownerId: string
}

export interface IGetCreditBalance extends IAction<CreditAccount | null, GetCreditBalanceArgs> {}
